export const COMPONENT_CREATED = 'COMPONENT_CREATED'
export const DATE_FILTER_UPDATED = 'DATE_FILTER_UPDATED'
export const GROUP_FILTER_UPDATED = 'GROUP_FILTER_UPDATED'
export const componentCreated = (name) => {
  return {
    type: COMPONENT_CREATED,
    data: {
      componentName: name
    }
  }
}

export const updateDateFilter = (name, dateFilter, dateInterval) => {
  if (dateInterval) {
    return {
      type: DATE_FILTER_UPDATED,
      data: {
        componentName: name,
        dateFilter,
        dateInterval
      }
    }
  } else {
    return {
      type: DATE_FILTER_UPDATED,
      data: {
        componentName: name,
        dateFilter
      }
    }
  }
}

export const updateGroupFilter = (name, groupFilter) => {
  return {
    type: GROUP_FILTER_UPDATED,
    data: {
      componentName: name,
      groupFilter
    }
  }
}
